// import React, { useState, useEffect } from "react";
// import { useLanguage } from "../../context/LanguageContext";
// import translations from "../../locals/translations.json";

// const ProcessSection = ({
//   apiEndpoint = "http://192.168.18.134:5000/api/pagesettings/homepage",
//   processSteps = null,
// }) => {
//   const [steps, setSteps] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const { language } = useLanguage();
//   const isRTL = language === "ar";
//   // Default process steps
//   const defaultSteps = [
//     {
//       number: 1,
//       title: "-",
//       description:
//         "Create your account and get verified to start bidding on exclusive car auctions with just a few simple steps.",
//       icon: "signup",
//     },
//     {
//       number: 2,
//       title: "-",
//       description:
//         "Secure your bidding position by making the required deposit payment through our trusted payment gateway.",
//       icon: "pay",
//     },
//     {
//       number: 3,
//       title: "-",
//       description:
//         "Place your bids on your favorite vehicles and compete with other bidders in real-time auction sessions.",
//       icon: "bid",
//     },
//   ];

//   // Function to transform API data to component format
//   const transformApiData = (apiData) => {
//     if (
//       !apiData?.value?.our_process ||
//       !Array.isArray(apiData.value.our_process)
//     ) {
//       return defaultSteps;
//     }

//     return apiData.value.our_process.map((item, index) => ({
//       number: index + 1,
//       title: item.col_title?.value || `Step ${index + 1}`,
//       description: item.col_description?.value || "No description available",
//       icon: getIconType(item.col_title?.value || "", index + 1),
//     }));
//   };

//   // Function to determine icon type based on title
//   const getIconType = (title, number) => {
//     const titleLower = title.toLowerCase();
//     if (
//       titleLower.includes("signup") ||
//       titleLower.includes("register") ||
//       titleLower.includes("account")
//     ) {
//       return "signup";
//     } else if (
//       titleLower.includes("pay") ||
//       titleLower.includes("payment") ||
//       titleLower.includes("deposit")
//     ) {
//       return "pay";
//     } else if (
//       titleLower.includes("bid") ||
//       titleLower.includes("auction") ||
//       titleLower.includes("car")
//     ) {
//       return "bid";
//     }
//     return "default";
//   };

//   // Fetch process steps from API if endpoint is provided
//   useEffect(() => {
//     const fetchProcessSteps = async () => {
//       if (!apiEndpoint) {
//         setSteps(processSteps || defaultSteps);
//         return;
//       }

//       try {
//         setLoading(true);
//         setError(null);

//         const response = await fetch(apiEndpoint);

//         if (!response.ok) {
//           throw new Error(`HTTP error! status: ${response.status}`);
//         }

//         const data = await response.json();

//         // Transform the API data to match our component structure
//         const transformedSteps = transformApiData(data);
//         setSteps(transformedSteps);
//       } catch (err) {
//         setError(err.message);
//         setSteps(defaultSteps); // Fallback to default steps
//         console.error("Error fetching process steps:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchProcessSteps();
//   }, [apiEndpoint, processSteps]);

//   // Icon component

//   if (loading) {
//     return <>looding</>;
//   }

//   return (
//     <section className='py-16  mx-auto max-w-7xl'>
//       <div className='relative rounded-3xl '>
//         <h2
//           className='text-4xl md:text-5xl font-extrabold text-center mb-12 w-full'
//           dir={isRTL ? "rtl" : "ltr"}
//         >
//           {translations[language].sectionHeadings.our}{" "}
//           <span className='text-primary'>
//             {translations[language].sectionHeadings.process}
//           </span>
//         </h2>

//         <div className='relative bg-[#fef8f6] rounded-3xl w-full  px-6 md:px-10 py-24 overflow-hidden'>
//           {/* Decorative curved line */}
//           <div className='hidden sm:block absolute top-[55%] left-0 w-full transform -translate-y-1/2 z-0'>
//             <svg
//               xmlns='http://www.w3.org/2000/svg'
//               width='1799'
//               height='295'
//               viewBox='0 0 1799 295'
//               fill='none'
//               className='w-full h-auto'
//             >
//               <g filter='url(#filter0_d_231_880)'>
//                 <path
//                   d='M-370.356 243.852C-272.656 187.993 -41.9672 73.0907 99.1951 60.3502C275.648 44.4245 338.986 136.54 610.094 105.202C881.202 73.8635 1059.69 -48.1543 1290.25 27.3857C1520.8 102.926 1637.14 159.622 1910.89 85.8787'
//                   stroke='#F57059'
//                   strokeWidth='5'
//                   strokeLinecap='round'
//                   strokeLinejoin='round'
//                 />
//               </g>
//               <defs>
//                 <filter
//                   id='filter0_d_231_880'
//                   x='-396.856'
//                   y='0.608398'
//                   width='2334.24'
//                   height='293.744'
//                   filterUnits='userSpaceOnUse'
//                   colorInterpolationFilters='sRGB'
//                 >
//                   <feFlood floodOpacity='0' result='BackgroundImageFix' />
//                   <feColorMatrix
//                     in='SourceAlpha'
//                     type='matrix'
//                     values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
//                     result='hardAlpha'
//                   />
//                   <feOffset dy='24' />
//                   <feGaussianBlur stdDeviation='12' />
//                   <feComposite in2='hardAlpha' operator='out' />
//                   <feColorMatrix
//                     type='matrix'
//                     values='0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 0 0.662745 0 0 0 0.3 0'
//                   />
//                   <feBlend
//                     mode='normal'
//                     in2='BackgroundImageFix'
//                     result='effect1_dropShadow_231_880'
//                   />
//                   <feBlend
//                     mode='normal'
//                     in='SourceGraphic'
//                     in2='effect1_dropShadow_231_880'
//                     result='shape'
//                   />
//                 </filter>
//               </defs>
//             </svg>
//           </div>

//           {/* Process Steps */}
//           <div className='relative z-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-16 px-4 sm:px-10 lg:px-20 pt-10'>
//             {steps.map((step, index) => (
//               <div
//                 key={step.number || index}
//                 className='relative w-full max-w-[320px] mx-auto flex flex-col items-start group'
//               >
//                 {/* Large number background */}
//                 <span className='absolute -top-10 left-20 text-[220px] md:text-[250px] font-black text-[#000000] opacity-5 z-0 leading-none select-none '>
//                   {step.number}
//                 </span>a

//                 {/* Icon container */}
//                 <div className='relative  z-10 w-[64px] h-[64px] bg-white rounded-[20px] shadow-md mb-8 flex items-center justify-center ml-4 mt-8   '>
//                   <div className='text-primary p-4 bg-[#C4C4C4] rounded-xl'>
//                     {/* <StepIcon type={step.icon} number={step.number} /> */}
//                   </div>
//                 </div>

//                 {/* Content */}
//                 <div className='flex flex-col justify-start items-start relative z-10 pl-4'>
//                   <h3 className='text-[38px] md:text-[42px] font-bold leading-tight mb-4 transition-colors duration-300 group-hover:text-primary'>
//                     {step.title}
//                   </h3>
//                   <p className='text-gray-600 text-[18px] leading-relaxed font-medium max-w-[280px] transition-colors duration-300 group-hover:text-gray-700'>
//                     {step.description}
//                   </p>
//                 </div>
//               </div>
//             ))}
//           </div>

//           {/* Error message if API fails */}
//           {error && (
//             <div className='absolute bottom-4 right-4 bg-red-100 border border-red-300 text-red-700 px-3 py-2 rounded-md text-sm'>
//               API Error: Using default content
//             </div>
//           )}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ProcessSection;

// import React, { useState } from "react";
// import { useLanguage } from "../../context/LanguageContext";
// import translations from "../../locals/translations.json";

// const OurProcess = ({ processData }) => {
//   const [steps, setSteps] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const { language } = useLanguage();
//   // const isRTL = language === "ar";
//   return (
//     <>
//       <section className='py-16  mx-auto '>
//         <div className='relative '>
//           <h2
//             className='text-4xl md:text-5xl text-black font-extrabold text-center mb-12 w-full'
//             // dir={isRTL ? "rtl" : "ltr"}
//           >
//             {translations[language].sectionHeadings.Get}{" "}
//             {translations[language].sectionHeadings.Started}{" "}
//             {translations[language].sectionHeadings.in}{" "}
//             <span className='text-primary'>
//               {translations[language].sectionHeadings["3"]}{" "}
//               {translations[language].sectionHeadings.Easy}{" "}
//             </span>
//             {translations[language].sectionHeadings.Steps}{" "}
//           </h2>
//           <p className='justify-center text-center text-[16px]  mb-8'>
//             Create your account, place your deposit, and enter the fast lane of
//             real-time car auctions. It’s that easy.
//           </p>
//           <div className='relative bg-[#414042] w-full  px-6 md:px-10 py-24 overflow-hidden'>
//             {/* Decorative curved line */}
//             <div className='hidden sm:block absolute top-[70%] left-0 w-full transform -translate-y-1/2 z-0'>
//               <svg
//                 xmlns='http://www.w3.org/2000/svg'
//                 width='1799'
//                 height='295'
//                 viewBox='0 0 1799 295'
//                 fill='none'
//                 className='w-full h-auto'
//               >
//                 <g filter='url(#filter0_d_231_880)'>
//                   <path
//                     d='M-370.356 243.852C-272.656 187.993 -41.9672 73.0907 99.1951 60.3502C275.648 44.4245 338.986 136.54 610.094 105.202C881.202 73.8635 1059.69 -48.1543 1290.25 27.3857C1520.8 102.926 1637.14 159.622 1910.89 85.8787'
//                     stroke='#e55a2b'
//                     strokeWidth='5'
//                     strokeLinecap='round'
//                     strokeLinejoin='round'
//                   />
//                 </g>
//                 <defs>
//                   <filter
//                     id='filter0_d_231_880'
//                     x='-396.856'
//                     y='0.608398'
//                     width='2334.24'
//                     height='293.744'
//                     filterUnits='userSpaceOnUse'
//                     colorInterpolationFilters='sRGB'
//                   >
//                     <feFlood floodOpacity='0' result='BackgroundImageFix' />
//                     <feColorMatrix
//                       in='SourceAlpha'
//                       type='matrix'
//                       values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
//                       result='hardAlpha'
//                     />
//                     <feOffset dy='24' />
//                     <feGaussianBlur stdDeviation='12' />
//                     <feComposite in2='hardAlpha' operator='out' />
//                     <feColorMatrix
//                       type='matrix'
//                       values='0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 0 0.662745 0 0 0 0.3 0'
//                     />
//                     <feBlend
//                       mode='normal'
//                       in2='BackgroundImageFix'
//                       result='effect1_dropShadow_231_880'
//                     />
//                     <feBlend
//                       mode='normal'
//                       in='SourceGraphic'
//                       in2='effect1_dropShadow_231_880'
//                       result='shape'
//                     />
//                   </filter>
//                 </defs>
//               </svg>
//             </div>
//             {/* Process Steps */}
//             <div className='relative z-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-16 px-4 sm:px-10 lg:px-20 pt-10'>
//               {processData.map((process, index) => (
//                 <div
//                   key={process.number || index}
//                   className='relative w-full max-w-[320px] mx-auto flex flex-col items-start group'
//                 >
//                   {/* Large number background */}
//                   <span className='absolute -top-10 left-20 text-[220px] md:text-[250px] font-black text-primary opacity-5 z-0 leading-none select-none '>
//                     {process.number}
//                   </span>

//                   {/* Icon container */}
//                   <div className='relative  z-10 w-[64px] h-[64px] bg-primary rounded-[20px] shadow-md mb-8 flex items-center justify-center ml-4 mt-8   '>
//                     <div className='text-primary p-4 bg-[#ffffff] rounded-xl'>
//                       {/* <StepIcon type={step.icon} number={step.number} /> */}
//                     </div>
//                   </div>

//                   {/* Content */}
//                   <div className='flex flex-col justify-start items-start relative z-10 pl-4'>
//                     <h3 className='text-[30px] md:text-[30px] text-primary font-bold leading-tight mb-4'>
//                       <div
//                         className=''
//                         dangerouslySetInnerHTML={{
//                           __html: process?.title,
//                         }}
//                       />
//                       {/* {process.title} */}
//                     </h3>
//                     <p className='text-white max-w-[280px]'>
//                       <div
//                         className=''
//                         dangerouslySetInnerHTML={{
//                           __html: process?.description,
//                         }}
//                       />
//                       {/* {process.description} */}
//                     </p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//             {/* Error message if API fails */}
//             {error && (
//               <div className='absolute bottom-4 right-4 bg-red-100 border border-red-300 text-red-700 px-3 py-2 rounded-md text-sm'>
//                 API Error: Using default content
//               </div>
//             )}
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default OurProcess;

import React, { useState } from "react";
import { useLanguage } from "../../context/LanguageContext";
import translations from "../../locals/translations.json";

const OurProcess = ({ processData = [] }) => {
  const [error, setError] = useState(null); // (unused – can remove)
  const { language } = useLanguage();

  // Do not render section if no usable data
  const hasProcessData =
    Array.isArray(processData) &&
    processData.some(
      (p) =>
        (p && (p.title || p.description)) ||
        (typeof p === "object" && Object.keys(p || {}).length > 0)
    );

  if (!hasProcessData) return null;

  return (
    <>
      <section className='py-10  mx-auto '>
        <div className='relative '>
          <h2 className='text-[20px] md:text-[30px]  text-black font-extrabold text-center  w-full'>
            {translations[language].sectionHeadings.Get}{" "}
            {translations[language].sectionHeadings.Started}{" "}
            {translations[language].sectionHeadings.in}{" "}
            <span className='text-primary'>
              {translations[language].sectionHeadings["3"]}{" "}
              {translations[language].sectionHeadings.Easy}{" "}
            </span>
            {translations[language].sectionHeadings.Steps}{" "}
          </h2>
          <p className='justify-center text-center text-[16px]  mb-8'>
            {translations[language]?.ourProcess?.description}
          </p>
          <div className='relative bg-[#414042] w-full  px-6 md:px-10 py-24 overflow-hidden'>
            {/* Decorative curved line */}
            <div className='hidden sm:block absolute top-[70%] left-0 w-full transform -translate-y-1/2 z-0'>
              {/* svg unchanged */}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='1799'
                height='295'
                viewBox='0 0 1799 295'
                fill='none'
                className='w-full h-auto'
              >
                <g filter='url(#filter0_d_231_880)'>
                  <path
                    d='M-370.356 243.852C-272.656 187.993 -41.9672 73.0907 99.1951 60.3502C275.648 44.4245 338.986 136.54 610.094 105.202C881.202 73.8635 1059.69 -48.1543 1290.25 27.3857C1520.8 102.926 1637.14 159.622 1910.89 85.8787'
                    stroke='#e55a2b'
                    strokeWidth='5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <filter
                    id='filter0_d_231_880'
                    x='-396.856'
                    y='0.608398'
                    width='2334.24'
                    height='293.744'
                    filterUnits='userSpaceOnUse'
                    colorInterpolationFilters='sRGB'
                  >
                    <feFlood floodOpacity='0' result='BackgroundImageFix' />
                    <feColorMatrix
                      in='SourceAlpha'
                      type='matrix'
                      values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                      result='hardAlpha'
                    />
                    <feOffset dy='24' />
                    <feGaussianBlur stdDeviation='12' />
                    <feComposite in2='hardAlpha' operator='out' />
                    <feColorMatrix
                      type='matrix'
                      values='0 0 0 0 0.215686 0 0 0 0 0.203922 0 0 0 0 0.662745 0 0 0 0.3 0'
                    />
                    <feBlend
                      mode='normal'
                      in2='BackgroundImageFix'
                      result='effect1_dropShadow_231_880'
                    />
                    <feBlend
                      mode='normal'
                      in='SourceGraphic'
                      in2='effect1_dropShadow_231_880'
                      result='shape'
                    />
                  </filter>
                </defs>
              </svg>
            </div>
            {/* Process Steps */}
            <div className='relative z-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 gap-16 px-4 sm:px-10 lg:px-20 pt-10 max-w-7xl mx-auto'>
              {processData.map((process, index) => (
                <div
                  key={process.number || index}
                  className='relative w-full max-w-[320px] mx-auto flex flex-col items-start group'
                >
                  <span className='absolute -top-10 left-20 text-[220px] md:text-[250px] font-black text-primary opacity-5 z-0 leading-none select-none '>
                    {process.number}
                  </span>
                  <div className='relative  z-10 w-[64px] h-[64px] bg-primary rounded-[20px] shadow-md mb-8 flex items-center justify-center ml-4 mt-8'>
                    <div className='text-primary p-4 bg-[#ffffff] rounded-xl'></div>
                  </div>
                  <div className='flex flex-col justify-start items-start relative z-10 pl-4'>
                    <h3 className='text-[30px] md:text-[30px] text-primary font-bold leading-tight mb-4'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: process?.title || "-",
                        }}
                      />
                    </h3>
                    <p className='text-white max-w-[280px]'>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: process?.description || "",
                        }}
                      />
                    </p>
                  </div>
                </div>
              ))}
            </div>
            {error && (
              <div className='absolute bottom-4 right-4 bg-red-100 border border-red-300 text-red-700 px-3 py-2 rounded-md text-sm'>
                API Error: Using default content
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default OurProcess;
